import script from "./XTransitionSlide.vue?vue&type=script&lang=ts&setup=true"
export * from "./XTransitionSlide.vue?vue&type=script&lang=ts&setup=true"

import "./XTransitionSlide.vue?vue&type=style&index=0&id=6ed02d66&lang=scss"

const __exports__ = script;

export default __exports__